import { Controller, useForm } from 'react-hook-form';
import React, { useContext, useState } from 'react';
import extendaLogo from '../../assets/img/extendaretail_logo_primary.png';
import { TenantInfoContext } from '../../providers/TenantInfo/TenantInfo';
import { LoginBtn, PageContainer, Logo, StyledToast, PageWrapper } from '../pages.styles';
import { Box, Flexbox, TextField, Typography, Link } from '@hiiretail/synergy-ui';
import { useTitle } from '../../hooks/useTitle';
import { useAuthProvider } from 'auth/useAuthProvider';

export const ResetPassword: React.FC = () => {
  useTitle('Reset Password');
  const { firebaseApp } = useAuthProvider();
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const { tenantInfo, loading } = useContext(TenantInfoContext);

  const { control, handleSubmit, formState } = useForm({
    mode: 'onChange',
  });

  const onSubmit = (data: { email: string }) => {
    if (tenantInfo && firebaseApp) {
      firebaseApp.auth().tenantId = tenantInfo.staffTenantId;
      firebaseApp
        .auth()
        .sendPasswordResetEmail(data.email)
        .then(() => {
          const message = `Password reset link sent to ${data.email}`;
          setToastOpen(true);
          setToastMessage(message);
        })
        .catch((e) => {
          setToastOpen(true);
          setToastMessage(e.message);
        });
    }
  };

  const handleToastClose = () => {
    setToastOpen(false);
  };

  return (
    <PageWrapper container direction="column" alignItems="center" justifyContent="center">
      <StyledToast
        className="test-toast"
        open={toastOpen}
        onHide={handleToastClose}
        autoHideDelay={30000}>
        {toastMessage}
      </StyledToast>
      {/*@ts-ignore*/}
      <PageContainer container direction="column" alignItems="center" justifyContent="center">
        <Box mb={4}>
          <Flexbox container direction="column" justifyContent="center" alignItems="center">
            <Logo src={extendaLogo} alt="" className="login-container-logo" />
            <Typography color={() => '#3c3364'} variant="header2">
              Reset your Hii Retail password
            </Typography>
          </Flexbox>
        </Box>
        {/*@ts-ignore*/}
        <form onSubmit={handleSubmit(onSubmit)}>
          <Flexbox container direction="column" gutter={3}>
            <Flexbox item>
              <Controller
                name="email"
                control={control}
                defaultValue=""
                rules={{
                  required: 'Email is required',
                  pattern: {
                    value:
                      /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z-]+\.)+[A-Za-z]{2,}))$/,
                    message: 'Invalid email address provided',
                  },
                }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    required
                    fullWidth
                    type="email"
                    autoComplete="email"
                    error={formState.errors?.email?.message?.toString()}
                    label="Email"
                    value={value}
                    onChange={onChange}
                    name="email"
                  />
                )}
              />
            </Flexbox>
          </Flexbox>
          <Box mt={10} />
          <Flexbox container direction="column" gutter={4}>
            <Flexbox item>
              <LoginBtn
                type="submit"
                disabled={!formState.isValid || !formState?.dirtyFields?.email || loading}
                variant="primary">
                Reset password
              </LoginBtn>
            </Flexbox>
            <Flexbox item alignSelf="center">
              <Link
                external={false}
                to={`${globalThis.location.origin}/login${globalThis.location.search}`}
                onClick={() => {
                  globalThis.location.href = `${globalThis.location.origin}/login${globalThis.location.search}`;
                }}>
                <Typography>Back to login</Typography>
              </Link>
            </Flexbox>
          </Flexbox>
        </form>
      </PageContainer>
    </PageWrapper>
  );
};
